import vueSeamless from "vue-seamless-scroll";
import echarts from "echarts"
import { WOW } from "../../utils/wow.min.js";
import '../../../node_modules/echarts/map/js/china.js' //引入中国地图

import { request, get } from '../../utils/axios';

export default {
  components: {
    vueSeamless: vueSeamless,
  },
  watch: {
    '$i18n.locale': function (newLang, oldLang) {
      if (newLang == 'en') {
        this.pointData = [{
          name: "South West",
          value: [104.104733, 30.652319]
        }, {
          name: "North China",
          value: [116.33943, 39.125274]
        }, {
          name: "East China",
          value: [121.504642, 31.24186]
        }, {
          name: "South China",
          value: [113.745411, 23.019925]
        }]
      } else {
        this.pointData = [{
          name: "西南",
          value: [104.104733, 30.652319]
        }, {
          name: "华北",
          value: [116.33943, 39.125274]
        }, {
          name: "华东",
          value: [121.504642, 31.24186]
        }, {
          name: "华南",
          value: [113.745411, 23.019925]
        }]
      }
      if (this.$refs.seamlessScrolls) {
        this.$nextTick(() => {
          this.defaultOption.autoPlay = true;
          this.$refs.seamlessScrolls.reset();
          this.$refs.seamlessScrolls._startMove();
        })
      }
      this.setEchartOption()

    }
  },
  computed: {
    defaultOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.newsList.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        autoPlay: true
      }
    }
  },
  data() {
    return {
      loginWidth: '',
      account: '',
      password: '',
      showMore: false,
      myChart: null,
      carouselHeight: null,
      background: require('../../assets/images/index/indexbg2.jpg'),
      backgroundList: [
        require('../../assets/images/index/indexbg1.jpg'),
        require('../../assets/images/index/indexbg2.jpg'),
        require('../../assets/images/index/indexbg3.jpg'),
        require('../../assets/images/index/indexbg4.jpg'),
        require('../../assets/images/index/indexbg5.jpg'),
        require('../../assets/images/index/indexbg6.jpg'),
        require('../../assets/images/index/indexbg7.jpg'),
        require('../../assets/images/index/indexbg8.jpg'),
        require('../../assets/images/index/indexbg9.jpg'),
        require('../../assets/images/index/indexbg10.jpg'),
        require('../../assets/images/index/indexbg11.jpg'),
        require('../../assets/images/index/indexbg12.jpg')
      ],
      menuTitle: 0,
      // 滚动条高点
      scrollTopTemp: 0,
      options: {},
      companyData: [
        // {
        //     name: "1",
        //     value: [121.592865,31.115115]
        // },
        // {
        //     name: "2",
        //     value: [115.777738,28.167043]
        // },
        // {
        //     name: "3",
        //     value: [120.450364,31.961817]
        // }
      ],
      pointData: [],
      dataList: [
        {
          name: "上海",
          value: 101
        },
        {
          name: "天津",
          value: 101
        },
        {
          name: "江苏",
          value: 101
        },
        {
          name: "江西",
          value: 101
        },
        {
          name: "广东",
          value: 101
        },
        {
          name: "四川",
          value: 101
        },
        {
          name: "河北",
          value: 101
        }
      ],
      products: [
        {
          id: 1,
          img: require("../../assets/images/index/warehousing.png")
        }, {
          id: 2,
          img: require("../../assets/images/index/diversifiedtransportoptions.png"),
        }, {
          id: 3,
          img: require("../../assets/images/index/internationalfreightforwarders.png"),
        }, {
          id: 4,
          img: require("../../assets/images/index/value-addedservices.png")
        }, {
          id: 5,
          img: require("../../assets/images/index/supplychainsolutions.png"),
        }, {
          id: 6,
          img: require("../../assets/images/index/more.svg"),
        }
      ],

      industries: [
        {
          id: 1,
          img: require("../../assets/images/index/appliedmaterials.svg"),
        }, {
          id: 2,
          img: require("../../assets/images/index/youqituliao.svg"),
        }, {
          id: 3,
          img: require("../../assets/images/index/runhuayou.svg"),
        }, {
          id: 4,
          img: require("../../assets/images/index/nonghua.svg")
        }, {
          id: 5,
          img: require("../../assets/images/index/dianzihuaxue.svg"),
        }, {
          id: 6,
          img: require("../../assets/images/index/xinnengyuan.svg"),
        }, {
          id: 7,
          img: require("../../assets/images/index/huaxueshiji.svg"),
        }, {
          id: 8,
          img: require("../../assets/images/index/more.svg"),
        }
      ],

      about: [
        {
          id: 1,
          img: require("../../assets/images/index/about1.png")
        }, {
          id: 2,
          img: require("../../assets/images/index/about2.jpg")
        }
      ],

      companyList: [],

      technology: {
        img: require("../../assets/images/index/technology.png")
      },

      security: {
        img: require("../../assets/images/index/security.png")
      },

      //echarts
      selCity: '上海',

      value: null,

      //首页最新滚动新闻
      newsList: [],
    };
  },
  methods: {
    showDetail() {
      this.showMore = !this.showMore
    },
    goTo(path) {
      this.$router.push({ path: path })
    },
    jumpIt(path) {
      this.$router.push({ path: path })
    },
    setBgImg(val) {
      this.background = this.backgroundList[val]
    },
    mouseLeave() {
      this.background = require('../../assets/images/index/indexbg2.jpg')
    },
    jumpTo(value) {
      if (value === 0) {
        this.$router.push('/news/groupNews')
      } else if (value === 1) {
        this.$router.push('/join/work')
      } else if (value === 2) {
        this.$router.push('/staffLogin')
      }
    },
    handleSelect(param) {
      // 调用父组件方法
      // this.$emit("handleSelect", param);
    },

    resize() {
      var width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      // var width =
      // document.documentElement.clientWidth ||
      // document.body.clientWidth;

      var fullHeight = window.screen.availHeight;
      var fullWidth = window.screen.availWidth;
      this.coverHeight = (fullHeight / fullWidth) * width;

      // 获取窗口的高度与宽度(不包含工具栏与滚动条):
      this.coverHeight = window.innerHeight;

      this.colWidth = width / 6;

      //浏览器可见区域宽度
      this.width = width;

      // 设置播放按钮位置
      this.playTop = this.coverHeight * 0.85 + "px";
    },

    // 鼠标移入，暂停无限滚动
    pause: function () {
      clearInterval(this.scrollInfiniteTimer)
    },



    // 禁止页面滚动
    stopMove() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      // 禁止页面滚动
      document.addEventListener("touchmove", m, { passive: false });
    },

    // 允许页面滚动
    allowMove() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "";
      document.removeEventListener("touchmove", m, { passive: true });
    },

    // 图片压缩
    // async compressImage() {
    //   var config = {width: 960, height: 439}
    //   for(var i=0; i<this.carouselList.length; i++) {
    //     await this.$compressImage(this.carouselList[i].img, config).then(data => {
    //       this.carouselList[i].img = data;
    //     });
    //   }
    // },


    // 轮播图改变事件，获取index
    changeCarouselIndex(event) {
      this.carouselIndex = event + 1;
    },

    changeNet(event) {
      var globalNet = this.$i18n.t('index.globalNet.net')
      globalNet.forEach(item => {
        if (item.id == event) {
          this.companyList = item.company
        }
      })
      console.log("companyList:", this.companyList)
    },
    changeMenu(value) {
      this.menuTitle = value
    },
    initMap() {
      var _this = this
      let mapDiv = document.getElementById('ChinaEchart-index')
      if (mapDiv) {
        let myChart = echarts.init(mapDiv);
        this.myChart = myChart
        myChart.setOption(this.options);
        myChart.on('click', function (params) {
          if (params.name == '上海' || params.name == '江苏' || params.name == '江西') {
            _this.$router.push('/globalNet/eastChina')
          } else if (params.name == '天津' || params.name == '河北') {
            _this.$router.push('/globalNet/northChina')
          } else if (params.name == '四川') {
            _this.$router.push('/globalNet/southwest')
          }
        })
      }
    },
    async selectChange(val) {
      this.changeNet(val)
      if (val == 1) {
        this.dataList = [{
          name: "上海",
          value: 201
        },
        {
          name: "天津",
          value: 101
        },
        {
          name: "江苏",
          value: 201
        },
        {
          name: "江西",
          value: 201
        },
        {
          name: "广东",
          value: 101
        },
        {
          name: "四川",
          value: 101
        },
        {
          name: "河北",
          value: 101
        }]
        this.companyData = [
          {
            name: "1",
            value: [121.613759, 31.176032]
          },
          {
            name: "2",
            value: [115.796046, 28.194305]
          },
          {
            name: "3",
            value: [120.477571, 32.005347]
          }
        ]
        await this.setEchartOption()
        await this.$router.push('/globalNet/eastChina')
      } else if (val == 2) {
        this.dataList = [
          {
            name: "上海",
            value: 101
          },
          {
            name: "天津",
            value: 201
          },
          {
            name: "江苏",
            value: 101
          },
          {
            name: "江西",
            value: 101
          },
          {
            name: "广东",
            value: 101
          },
          {
            name: "四川",
            value: 101
          },
          {
            name: "河北",
            value: 201
          }
        ]
        this.companyData = [
          {
            name: "1",
            value: [117.259271, 39.243253]
          },
          {
            name: "2",
            value: [117.507389, 38.352885]
          }
        ]
        await this.setEchartOption()
        await this.$router.push('/globalNet/northChina')
      } else if (val == 3) {
        this.dataList = [
          {
            name: "上海",
            value: 101
          },
          {
            name: "天津",
            value: 101
          },
          {
            name: "江苏",
            value: 101
          },
          {
            name: "江西",
            value: 101
          },
          {
            name: "广东",
            value: 101
          },
          {
            name: "四川",
            value: 201
          },
          {
            name: "河北",
            value: 101
          }
        ]
        this.companyData = [
          {
            name: "1",
            value: [104.348153, 30.704807]
          }
        ]
        await this.setEchartOption()
        await this.$router.push('/globalNet/southwest')
      } else if (val == 4) {
        this.dataList = [
          {
            name: "上海",
            value: 101
          },
          {
            name: "天津",
            value: 101
          },
          {
            name: "江苏",
            value: 101
          },
          {
            name: "江西",
            value: 101
          },
          {
            name: "广东",
            value: 201
          },
          {
            name: "四川",
            value: 101
          },
          {
            name: "河北",
            value: 101
          }
        ]
        this.companyData = [
          // {
          //   name: "1",
          //   value: [121.592865,31.115115]
          // },
          // {
          //   name: "2",
          //   value: [115.777738,28.167043]
          // },
          // {
          //   name: "3",
          //   value: [120.450364,31.961817]
          // }
        ]
      } else {
        this.dataList = [
          {
            name: "上海",
            value: 101
          },
          {
            name: "天津",
            value: 101
          },
          {
            name: "江苏",
            value: 101
          },
          {
            name: "江西",
            value: 101
          },
          {
            name: "广东",
            value: 101
          },
          {
            name: "四川",
            value: 101
          },
          {
            name: "河北",
            value: 101
          }
        ]
        this.companyData = [
          // {
          //   name: "1",
          //   value: [121.592865,31.115115]
          // },
          // {
          //   name: "2",
          //   value: [115.777738,28.167043]
          // },
          // {
          //   name: "3",
          //   value: [120.450364,31.961817]
          // }
        ]
      }
      this.setEchartOption()
      // this.initMap()
    },
    //修改echart配制
    setEchartOption() {
      var lang = this.$i18n.locale
      this.options = {
        visualMap: {
          min: 0,
          max: 1000,
          left: 26,
          bottom: 0,
          seriesIndex: [0],
          pieces: [{
            gte: 0,
            lte: 102,
            label: lang == 'zh' ? '未选中区域' : 'Unselected Area',
            color: "#cdcdcd"
          }, {
            gt: 200,
            color: "#ED6D00",
            label: lang == 'zh' ? '选中区域' : 'Selected Area'
          }],
          show: true,
          orient: 'horizontal',
        },
        geo: {
          map: "china",
          zoom: 1.2,
          top: 40,
          label: {
            normal: {
              show: false,
            },
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#d9d9d9",
              borderColor: "#ffffff"
            },
            emphasis: {
              areaColor: "#d9d9d9",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0
            }
          },
          regions: [{
            name: '上海',
            itemStyle: {
              emphasis: {
                areaColor: '#ED6D00'
              }
            }
          }, {
            name: '天津',
            itemStyle: {
              emphasis: {
                areaColor: '#ED6D00'
              }
            }
          }, {
            name: '江苏',
            itemStyle: {
              emphasis: {
                areaColor: '#ED6D00'
              }
            }
          }, {
            name: '江西',
            itemStyle: {
              emphasis: {
                areaColor: '#ED6D00'
              }
            }
          }, {
            name: '广东',
            itemStyle: {
              emphasis: {
                areaColor: '#ED6D00'
              }
            }
          }, {
            name: '四川',
            itemStyle: {
              emphasis: {
                areaColor: '#ED6D00'
              }
            }
          }, {
            name: '河北',
            itemStyle: {
              emphasis: {
                areaColor: '#ED6D00'
              }
            }
          }]
        },
        series: [
          {
            name: "",
            type: "map",
            geoIndex: 0,
            data: this.dataList,
            itemStyle: {
              normal: {
                color: '#717171' //标志颜色
              },
              emphasis: {
                show: false,
              }
            }
          },
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            data: this.pointData,
            symbol: 'circle',
            symbolSize: [6, 6],
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  return params.name
                },
                position: 'top',
                color: '#495057',
                fontSize: '16'
              }
            },
            itemStyle: {
              color: '#ED6D00',
            }
          },
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            data: this.companyData,
            symbol: "image://" + require('@/assets/images/location.svg'),
            symbolSize: [15, 15],
            label: {
              show: false
            },
            itemStyle: {
              color: 'red'
            },
            zlevel: 1
          }
        ]
      }
      this.$nextTick(() => {
        this.initMap();
      })
    },

    getNewsList() {
      let params = {
      }
      let url = "/newsapi/api/news/getnew/list";
      get(url, params).then((res) => {
        if (res.data.code == 200) {
          let newsList = res.data.data;
          if (newsList.length > 0) {
            newsList.forEach((item, index) => {
              if (item.releaseDate) {
                let releaseDateList = item.releaseDate.split('-');
                let showDate = releaseDateList[1] + '.' + releaseDateList[2];
                item.showDate = showDate;
              }
            })
          }
          this.newsList = newsList;
        }
      })
    },

    openDetail(item) {
      let lang = this.$i18n.locale;
      let itemData = JSON.parse(item.dataset.item);
      let href = '';
      if (lang == 'zh') {
        href = itemData.url ? itemData.url : '';
      } else {
        href = itemData.urlEn ? itemData.urlEn : '';
      }
      window.open(href, '_blank')
    },

    // 在vue-seamless-scroll外部的div添加点击事件，获取$event的target
    handleClickOpenDetail(e) {
      const item = e.target.closest(".seamless-warp-item"); // 定位元素
      if (item) {
        let lang = this.$i18n.locale;
        let itemData = JSON.parse(item.dataset.item);
        let href = '';
        if (lang == 'zh') {
          href = itemData.url ? itemData.url : '';
        } else {
          href = itemData.urlEn ? itemData.urlEn : '';
        }
        window.open(href, '_blank')
      }
    }
  },

  created: function () {
    this.loginWidth = document.body.clientWidth / 3
    if (this.loginWidth < 300) {
      this.loginWidth = 300
    }
    if (this.$i18n.locale == 'en') {
      this.pointData = [{
        name: "South West",
        value: [104.104733, 30.652319]
      }, {
        name: "North China",
        value: [116.33943, 39.125274]
      }, {
        name: "East China",
        value: [121.504642, 31.24186]
      }, {
        name: "South China",
        value: [113.745411, 23.019925]
      }]
    } else {
      this.pointData = [{
        name: "西南",
        value: [104.104733, 30.652319]
      }, {
        name: "华北",
        value: [116.33943, 39.125274]
      }, {
        name: "华东",
        value: [121.504642, 31.24186]
      }, {
        name: "华南",
        value: [113.745411, 23.019925]
      }]
    }
    this.setEchartOption()
    this.changeNet(1)
  },

  mounted: function () {
    this.getNewsList();
    console.log(document.body.clientWidth)
    var screenWidth = document.body.clientWidth
    if (screenWidth >= 1903) {
      this.carouselHeight = 640 + 'px'
    } else if (screenWidth >= 1730 && screenWidth < 1903) {
      this.carouselHeight = 612 + 'px'
      // this.carouselHeight = 592 + 'px'
    } else if (screenWidth >= 1522 && screenWidth < 1730) {
      this.carouselHeight = 557 + 'px'
      // this.carouselHeight = 507 + 'px'
    } else if (screenWidth >= 1349 && screenWidth < 1522) {
      this.carouselHeight = 484 + 'px'
    } else if (screenWidth >= 1269 && screenWidth < 1349) {
      this.carouselHeight = 455 + 'px'
    } else if (screenWidth > 768 && screenWidth < 1269) {
      this.carouselHeight = 455 + 'px'
    } else if (screenWidth < 1269) {
      this.carouselHeight = 200 + 'px'
    }
    let _this = this
    // var timer = setInterval(function () {
    //   _this.carouselHeight = document.getElementById('videos').offsetHeight + 'px'
    //   if (_this.carouselHeight !== '0px') {
    //     clearInterval(timer)
    //   }
    // }, 500)
    window.addEventListener('resize', function () {
      if (_this.resizeTimer) clearTimeout(_this.resizeTimer)
      _this.resizeTimer = setTimeout(function () {
        _this.myChart.resize()
        // _this.carouselHeight = _this.$refs.bannerHeight.height + 'px'
        // _this.carouselHeight = document.getElementById('videos').offsetHeight + 'px'
      }, 100)
    })
    new WOW().init()
    // this.resize();
    // window.addEventListener("resize", this.resize);
  },

  destroyed: function () {
    // window.removeEventListener("scroll", this.scrollBody);
    // window.removeEventListener("scroll", this.getScrollTop);
    // window.removeEventListener("resize", this.resize);

    // 页面销毁，运行滚动
    // this.allowMove();

    // this.closeRegistration();
  },

  // beforeUpdate: function () {
  //   if (this.$refs.seamlessScrolls) {
  //     this.$nextTick(() => {
  //       this.defaultOption.autoPlay = true;
  //       this.$refs.seamlessScrolls.reset();
  //       this.$refs.seamlessScrolls._startMove();
  //     })
  //   }
  // },

  updated: function () {
    if (this.$refs.seamlessScrolls) {
      this.$nextTick(() => {
        this.defaultOption.autoPlay = true;
        this.$refs.seamlessScrolls.reset();
        this.$refs.seamlessScrolls._startMove();
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/index/index.vue.js